import apiClient from './apiClient';
import type { ApiResponse } from '../types/api';

export interface ConsultationLabOrder {
    id: number;
    consultation_id: number;
    test_id?: number | null;
    panel_id?: number | null;
    test_name: string;
    instructions?: string;
    urgency: 'routine' | 'urgent' | 'stat';
    result?: string | null;
    result_date?: string | null;
    test?: {
        id: number;
        name: string;
        code: string;
        unit?: string;
    };
    panel?: {
        id: number;
        name: string;
        code: string;
    };
    created_at?: string;
}

interface PaginatedData<T> {
    data: T[];
    pagination?: { current_page: number; last_page: number; total: number };
}

export const consultationLabOrderService = {
    async getByConsultation(consultationId: number): Promise<ConsultationLabOrder[]> {
        const response = await apiClient.get<PaginatedData<ConsultationLabOrder>>(
            `/consultation-lab-orders?consultation_id=${consultationId}&per_page=50`
        );
        return response.data.data;
    },

    async create(data: {
        consultation_id: number;
        test_id?: number | null;
        panel_id?: number | null;
        test_name: string;
        instructions?: string;
        urgency?: string;
    }): Promise<ConsultationLabOrder> {
        const response = await apiClient.post<ApiResponse<ConsultationLabOrder>>(
            '/consultation-lab-orders',
            data
        );
        return response.data.data;
    },

    async update(id: number, data: Partial<{
        test_name: string;
        instructions: string;
        urgency: string;
        result: string;
        result_date: string;
    }>): Promise<ConsultationLabOrder> {
        const response = await apiClient.put<ApiResponse<ConsultationLabOrder>>(
            `/consultation-lab-orders/${id}`,
            data
        );
        return response.data.data;
    },

    async delete(id: number): Promise<void> {
        await apiClient.delete(`/consultation-lab-orders/${id}`);
    },
};

export default consultationLabOrderService;